import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useItemScope } from '@app/purchased-goods/components/item-detail/use-item-scope';
import { useGetPurchasedPackagingItemRecords } from '@shared/api/hooks/purchased-goods/packaging';
import PurchasedPackagingItemPurchasesTable from '../components/item/purchased-packaging-item-purchases-table';
import { usePurchasedPackagingItem } from '../purchased-packaging-item-context';

export default function PurchasedPackagingItemPurchasesPage() {
  const { item } = usePurchasedPackagingItem();
  const { recordsParams } = useItemScope();

  const { page, perPage, sort } = useDataTableQueryState();

  const {
    data,
    status,
    isLoading,
    isFetching,
    isPreviousData,
    isFetchedAfterMount,
  } = useGetPurchasedPackagingItemRecords({
    activityUuid: item.uuid,
    params: {
      page_size: perPage,
      page,
      ...recordsParams,
      sort: formatMultipleSortingForEndpoint(sort! || []),
    },
  });
  return (
    <Page name={`${item.packagingName} purchases`} page="subpage">
      <PurchasedPackagingItemPurchasesTable
        data={data!}
        status={status}
        isLoading={isLoading}
        isFetching={isFetching}
        isPreviousData={isPreviousData}
        isFetchedAfterMount={isFetchedAfterMount}
      />
    </Page>
  );
}
